module.exports = __webpack_public_path__ + "static/img/loading_1.760942a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static_dazzle/images/loading_1.gif
// module id = oJoo
// module chunks = 1